import { render, staticRenderFns } from "./TwilioFilters.vue?vue&type=template&id=22a79d2e&scoped=true"
import script from "./TwilioFilters.vue?vue&type=script&lang=js"
export * from "./TwilioFilters.vue?vue&type=script&lang=js"
import style0 from "./TwilioFilters.vue?vue&type=style&index=0&id=22a79d2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a79d2e",
  null
  
)

export default component.exports